import { createMutation, createQuery } from '@tanstack/svelte-query'
import { getCurrentUser, signOut } from '../api'
import queryClient from '../constants/query-client'
import { goToLogoutPortal } from '../helpers/oauth'
import { isAxiosError } from 'axios'

const retry = (retryCount: number, error: Error) => {
  if (isAxiosError(error) && error.response?.status === 401) return false

  return retryCount < 3
}

export const useCurrentUser = () => createQuery(() => ({
  queryKey: ['currentUser'],
  queryFn: () => getCurrentUser(),
  retry,
}), () => queryClient)

const useAuth = () => {
  const signoutMutation = createMutation(() => ({
    mutationFn: signOut,
    onSuccess: () => {
      queryClient.resetQueries()
      // Full single sign-out: end the shared Account Center session, which then
      // redirects back to /sign-in.
      goToLogoutPortal()
    },
  }), () => queryClient)

  return {
    signoutMutation,
    useCurrentUser,
  }
}

export default useAuth
